
    const data = {"name":"src/core/icons/circle-medium","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 8a4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            